import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgComponent(props) {
  let fill = "#FFED4F";
  if (props.fill) {
    fill = props.fill;
  }

  return (
    <Svg
      width={props.width || 21}
      height={props.height || 21}
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        d="M7.549.927c.3-.921 1.603-.921 1.902 0l1.182 3.637a1 1 0 00.95.691h3.825c.97 0 1.372 1.24.588 1.81l-3.094 2.247a1 1 0 00-.363 1.118l1.182 3.638c.299.92-.755 1.687-1.54 1.118l-3.093-2.248a1 1 0 00-1.176 0l-3.094 2.248c-.784.57-1.838-.197-1.539-1.118l1.182-3.638a1 1 0 00-.363-1.118L1.004 7.064c-.784-.57-.381-1.809.588-1.809h3.824a1 1 0 00.951-.69L7.55.926z"
        fill={fill}
      />
    </Svg>
  );
}

export default SvgComponent;
